export function PrintStyles() {
  return (
    <style>{`
      @media print {
        @page { size: landscape; margin: 0.3in 0.4in; }
        html, body { margin: 0 !important; padding: 0 !important; }
        body * { visibility: hidden !important; }
        .print-area, .print-area * { visibility: visible !important; }
        .print-area {
          position: absolute !important;
          left: 0 !important; top: 0 !important;
          width: 100% !important;
          padding: 0 !important; margin: 0 !important;
        }
        .no-print, nav, aside, header, footer, [data-testid="sidebar"],
        .no-print * { display: none !important; }
        .print-title {
          display: block !important; visibility: visible !important;
          font-size: 18px !important; font-weight: 700 !important;
          text-align: center !important; margin-bottom: 2px !important;
        }
        .print-subtitle {
          display: block !important; visibility: visible !important;
          font-size: 11px !important; text-align: center !important;
          margin-bottom: 8px !important; color: #555 !important;
        }
        table { border-collapse: collapse !important; width: 100% !important; page-break-inside: auto; }
        tr { page-break-inside: avoid; }
        th, td { border: 1.5px solid #444 !important; padding: 4px 6px !important; font-size: 10px !important; }
        th { font-size: 11px !important; font-weight: 700 !important; color: #000 !important; background: #e5e7eb !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .today-card { break-inside: avoid; }
        * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      }
      @media print {
        .print-area-today { position: absolute !important; left: 0 !important; top: 0 !important; width: 100% !important; }
      }
    `}</style>
  );
}

export function TodayPrintStyle({ active }) {
  if (!active) return null;
  return (
    <style>{`
      @media print {
        @page { size: portrait !important; margin: 0.3in !important; }
        .print-area-today table { width: 100% !important; }
        .print-area-today th, .print-area-today td {
          font-size: 11px !important; padding: 6px 8px !important;
        }
        .print-area-today .today-card td { page-break-inside: avoid; }
      }
    `}</style>
  );
}
